import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ButtonComponent from '@ui/components/Button/Button.component';
import LinkComponent from '@ui/components/Link/Link.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const MoutionBox = motion(Box);

const Component: React.FC<IProps> = ({ lang, approved, onApprove }) => {
    const getWord = useDictionary();

    return (
        <AnimatePresence>
            {!approved && (
                <MoutionBox
                    className="cookies-policy__wrap"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 90, opacity: 1 }}
                    transition={{
                        type: 'spring',
                        duration: 0.7,
                        stiffness: 100,
                        damping: 10,
                    }}
                    exit={{ height: 0, opacity: 0 }}
                >
                    <Box className="cookies-policy__content">
                        <Typography className="cookies-policy__text">
                            {`${getWord('cookiesPolicyAcceptance')} `}
                            <LinkComponent
                                href="/public/pdf/cookies.pdf"
                                text="more"
                                lang={lang}
                            />
                        </Typography>
                        <ButtonComponent
                            label="agree"
                            color="cookies"
                            lang={lang}
                            onClick={onApprove}
                        />
                    </Box>
                </MoutionBox>
            )}
        </AnimatePresence>
    );
};

const CookiesPolicyComponent = React.memo(Component);

export default CookiesPolicyComponent;
